import React, { useState, useRef } from 'react'
import styled from 'styled-components'
import { DatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers'
import DateFnsUtils from '@date-io/date-fns'
import CalendarTodayIcon from '@material-ui/icons/CalendarToday'
import ClickAwayListener from '@material-ui/core/ClickAwayListener'


const Wrapper = styled.div`
  position: relative;
  display: inline-block;
  width: 100%;
`

const InputWrapper = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  height: 42px;
  padding: 8px 10px;
  cursor: pointer;
  border-radius: 6px;
  border: 0.909px solid #E2E8F0;
  background: #F8FAFC;
`

const Input = styled.input`
  width: 100%;
  flex-shrink: 0;
  align-self: stretch;
  border: none;
  outline: none;
  font-size: 14px;
`
const CalendarWrapper = styled.div`
  position: absolute;
  top: calc(100% + 6px);
  right: 0;
  z-index: 10;
  background: white;
`
const ContainerValue = styled.div`
  display: flex;
  height: 35px;
  padding: 8px 12px 8px 12px;
  justify-content: flex-end;
  align-items: center;
  align-self: stretch;
  border-radius: 6px;
  background: rgba(255, 255, 255, 0.30);
`

const StyledDatePicker = styled(DatePicker)`
  background-color: green !important;

  .MuiPickersDay-daySelected {
    background-color: green !important;
  }
`

export default function DateInputWithCalendar({
  value,
  onChange,
  locale,
  disabled = false,
  icon = null,
  fontSize = '16px',
  inputBg = 'white'
}) {
  const [open, setOpen] = useState(false)

  const formatDate = (val) => {
    const date = new Date(val)

    const mm = String(date.getMonth() + 1).padStart(2, '0')
    const dd = String(date.getDate()).padStart(2, '0')
    const yyyy = date.getFullYear();

    return `${mm}/${dd}/${yyyy}`
  }

  const formatDateMMDDYYYY = (val) => {
    const date = new Date(val)

    const mm = String(date.getUTCMonth() + 1).padStart(2, "0")
    const dd = String(date.getUTCDate()).padStart(2, "0")
    const yyyy = date.getUTCFullYear()

    return `${mm}/${dd}/${yyyy}`
  }

  return (
    <>
    {disabled ? <ContainerValue>{value ? (value instanceof Date && !isNaN(value) ? formatDate(value) : formatDateMMDDYYYY(value)) : ''}</ContainerValue> : 
    <MuiPickersUtilsProvider utils={DateFnsUtils} locale={locale}>
      <ClickAwayListener onClickAway={() => setOpen(false)}>
        <Wrapper>
          <InputWrapper onClick={() => setOpen(prev => !prev)}>
            {icon && icon}
            <Input
              readOnly
              value={value ? value instanceof Date && !isNaN(value) ? formatDate(value) : formatDateMMDDYYYY(value) : ''}
              placeholder=""
              disabled={disabled}
              style={{ fontSize, background: inputBg, textAlign: 'left' }}
            />
          </InputWrapper>

          {open && !disabled && (
            <CalendarWrapper>
              <StyledDatePicker
                autoOk
                value={value}
                onChange={date => {
                  onChange(date)
                  setOpen(false)
                }}
                variant="static"
                views={['year', 'month', 'date']}
                hiddenLabel
              //disableToolbar
              />
            </CalendarWrapper>
          )}
        </Wrapper>
      </ClickAwayListener>
    </MuiPickersUtilsProvider>}
    </>
  )
}
